import { Dictionary } from '../../utils/languages';

const translations = {
  Market: {
    ENG: 'Market'
  },
  'Total Supply': {
    ENG: 'Total Supply'
  },
  'Total Borrowed': {
    ENG: 'Total Borrowed'
  },
  'Supply APY': {
    ENG: 'Supply APY'
  },
  'Borrow APY': {
    ENG: 'Borrow APY'
  },
  'Farming APY': {
    ENG: 'Farming APY'
  },
  'Leveraged LP APY': {
    ENG: 'Leveraged LP APY'
  }
} as Dictionary;

export default translations;
